import type { ReactNode } from 'react';
import { PageBackButton } from './PageBackButton';

export function PremiumPage({
  title,
  children,
  right,
  onBack,
  backLabel = 'Back',
  className = '',
}: {
  title?: string;
  children: ReactNode;
  right?: ReactNode;
  onBack?: () => void;
  backLabel?: string;
  className?: string;
}) {
  return (
    <div
      className={`mx-auto w-full max-w-2xl space-y-4 px-4 pb-2 pt-[max(calc(env(safe-area-inset-top,0px)+0.75rem),0.75rem)] md:pt-2 ${className}`}
    >
      {title ? (
        <div className="flex items-center gap-3 pb-0.5">
          {onBack ? <PageBackButton onClick={onBack} label={backLabel} /> : null}
          <h1 className="min-w-0 flex-1 font-display text-xl font-bold tracking-tight text-[var(--text-primary)] sm:text-2xl">
            {title}
          </h1>
          {right ? <div className="shrink-0">{right}</div> : null}
        </div>
      ) : null}
      {children}
    </div>
  );
}
